module.exports = __webpack_public_path__ + "static/media/SDG16.0e024a3d.mp4";